import useGlobalData from '@hooks/useGlobalData';
import styled from '@emotion/styled';
import { Link } from 'gatsby';
import tw from 'twin.macro';
import Menu from './Menu';
import Search from '@components/Search/Search';
import VersionsDropdown from './VersionsDropdown';
import { ImageElement } from '@kontent-ai/gatsby-components';
import MenuFooter from './MenuFooter';

const Navigation = ({ pageContext }: { pageContext: PageContext }) => {
  const {
    logo: { description: logoDescription, title: logoTitle, url: logoUrl },
    getHomepageByVersion,
    getInternalLink,
    latestVersion,
  } = useGlobalData();

  const selectedVersion = pageContext.versionNumber || latestVersion;
  const selectedHomepage = getHomepageByVersion(selectedVersion);

  if (!selectedHomepage) {
    return null;
  }

  const homePageUrl = getInternalLink({ page: selectedHomepage });
  const pages = selectedHomepage?.value?.subpages?.value;

  return (
    <NavigationWrapper>
      <NavigationHeader>
        <HomeLink to={homePageUrl}>
          <ImageElement
            alt={logoDescription}
            loading="eager"
            image={{
              height: 46,
              image_id: logoUrl,
              url: logoUrl,
              width: 160,
            }}
            title={logoTitle}
          />
        </HomeLink>
        <VersionsDropdown selectedVersion={selectedVersion} />
      </NavigationHeader>
      <Search selectedVersion={selectedVersion} />
      {pages && <Menu pages={pages} />}
      <MenuFooter />
    </NavigationWrapper>
  );
};

const HomeLink = styled(Link)`
  ${tw`block`};
  ${tw`mr-2 `}
`;

const NavigationWrapper = styled.nav`
  ${tw`overflow-y-auto sticky h-[100vh] top-12`};
  ${tw`flex-grow-0 flex flex-col`};
`;

const NavigationHeader = styled.header`
  ${tw`flex flex-row items-end justify-between`}
  ${tw`mx-8 pb-4 mt-10 mb-10`}
  ${tw`border-b-[1px] border-border`}
`;

export default Navigation;
